export function handleTargetButtons() {
  const targetButtonEls = document.querySelectorAll('.js-target')

  targetButtonEls.forEach(targetButtonEl => {
    targetButtonEl.addEventListener('click', () => {
      window.targetName = targetButtonEl.dataset.target
    })
  })
}

export function sendTarget() {
  if (window.targetName) {
    try {
      window.yaCounter4175221.reachGoal(window.targetName)
      window.yaCounter4175221.reachGoal('send_form_ok')

    } catch (e) {
      console.error(e)
    }

    try {
      window.dataLayer.push({'event': window.targetName})
    } catch (e) {
      console.error(e)
    }
  }
}